<div class="dialog-container">
    <div class="dialog-header">
        <h4 class="dialog-heading">Manage Users</h4>
        <button type="button" class="close-button" (click)="close()">
        <svg width="26px" height="24px" viewBox="0 0 26 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Nav-Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                <g id="Genre" transform="translate(-1438.000000, -32.000000)" class="inner-stroke" stroke="#FFFFFF">
                    <g id="Genre-Options">
                        <g id="Close" transform="translate(1439.000000, 32.000000)">
                            <path d="M24,0 L0,24" id="Path"></path>
                            <path d="M0,0 L24,24" id="Path"></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
        </button>
    </div>
<mat-dialog-content>
    <app-loader *ngIf="list.loadingUser" color="#50e3c2"></app-loader>
    <div class="dialog-body form-container "  *ngIf="!list.loadingUser">
        <div class="add-to-folder">
            <h6 class="label">Available Users<button type="button" class="action" (click)="deselectAll()"><small>Deselect all ({{selectedUserCount}})</small></button></h6>
            <span></span>
            <input class="search" [(ngModel)]="searchUsers" placeholder="Find a user">
            <ul class="list">
                <li *ngFor="let client of selectedArrayList | filter : searchUsers; let idx = index">
                    <mat-checkbox  [checked]= "client.checked" (change)="mySelectOpt(client.id, $event, idx)">
                        <span class="check-text">{{client?.name}}</span>
                    </mat-checkbox>
                </li>
            </ul>
        </div>
        <p class="note">Select or deselect or applicable permissions</p>
        <mat-checkbox (change)="selectAll($event)" [checked]="allselectUser">
            <span class="check-text">Select All</span>
        </mat-checkbox>
        <div class="form-col">
            <button class="form-button" (click)="updateUser(currentUserGroups)">Update</button>
            <button class="form-button form-button-cancel" (click)="close()">Cancel</button>
        </div>
    </div>
</mat-dialog-content> 
</div>
<div class="loading-overlay" *ngIf="loadingUserUpdate">
    <app-loader></app-loader>
</div>
